import {authGuard} from '@common/auth/guards/auth-route';
import {shouldRevalidateDatatableLoader} from '@common/datatable/filters/utils/should-revalidate-datatable-loader';
import {queryClient} from '@common/http/query-client';
import {searchParamsFromUrl} from '@ui/utils/urls/search-params-from-url';
import {RouteObject} from 'react-router';
import {adminShareableLinksQuery} from './use-admin-shareable-links';

export const adminShareableLinksRoutes: Record<string, RouteObject> = {
  index: {
    path: 'shareable-links',
    shouldRevalidate: shouldRevalidateDatatableLoader,
    lazy: () => import('@app/admin/shareable-links/shareable-links-index-page'),
    loader: ({request}) => {
      // super-admin only (matches the isAdmin backend guard)
      const redirect = authGuard({permission: 'admin'});
      if (redirect) return redirect;
      return queryClient.ensureQueryData(
        adminShareableLinksQuery(searchParamsFromUrl(request.url)),
      );
    },
  },
};
